<div class="flex flex-col gap-1">
  <span class="font-semibold">{{ coverage() | appNumber: '1.0-0' }} %</span>
  <span class="text-muted-color text-xs">
    {{ 'project.steps.rfp.invitationList.matrix.functions' | transloco }}
    {{ functionCoverage() | appNumber: '1.0-0' }} % ·
    {{ 'project.steps.rfp.invitationList.matrix.countries' | transloco }}
    {{ countryCoverage() | appNumber: '1.0-0' }} %
  </span>
</div>
